import { gql } from '@apollo/client';

export const USER_INFO_QUERY = gql`
  query userInfo {
    userInfo {
      userId
      partnerId
      partnerName
      firstName
      lastName
      userAdditionalData {
        userId
        avatar
      }
    }
  }
`;

export const RIGHTS_INFO_QUERY = gql`
  query rightsInfo {
    rightsInfo {
      hasAccess
      isAdmin
      rights
    }
  }
`;

export const USER_MENUS_QUERY = gql`
  query userMenus {
    userMenus {
      menuItems {
        caption
        description
        menuIcon
        menuItemId
        menuRoute
        orderNo
      }
    }
  }
`;
